import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'

ReactDOM.render((
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <HashRouter basename='/'>
        <App /> {/* The various pages will be displayed by the `Main` component. */}
      </HashRouter>
    </I18nextProvider>
  </React.StrictMode>
    ), document.getElementById('root')
  );
  

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
